import React, { useState,useEffect } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import AnalysisIcon from '@mui/icons-material/Assessment'; // 假设这是分析题目的图标
import 'katex/dist/katex.min.css';
import katex from 'katex';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from '../../SnackbarProvider';
import { requestUrl } from '../../requestUrl';
import LoadingData from '../dataloading';
import CustomButton from '../../components/CustomButton';
import { getColorDark,getColorLight ,getTheme} from '../../ColorManager';
import { Button,Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Pagination,Modal,Checkbox ,TextField,Chip } from '@mui/material';

import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import WangEditorLectures from './WangEditorLectures';
import { event } from 'jquery';

import { DialogActions, MenuItem, Select, FormControl, InputLabel } from '@mui/material';


import "dayjs/locale/zh-cn"; // 引入中文语言包

dayjs.locale("zh-cn"); // 全局设置 dayjs 为中文


// 外面的壳子
const LecturesContent = () => {
  const showSnackbar = useSnackbar();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [loadingText,setLoadingText] = useState('loading');
  const [userid,setUserid] = useState(0);
  const [colorManager, setColorManager] = useState(getColorDark()); // 初始化为空数组
  const[rolename,setRolename] = useState('user');
  const [eventData,setEventData] = useState({});


  // 模拟数据：某些日期有事件
const eventData1 = {
    "2025-03-10": { title: "项目会议", details: "讨论新的开发进度" },
    "2025-03-15": { title: "产品发布", details: "新版本产品上线" },
    "2025-03-22": { title: "团队建设", details: "公司组织户外拓展" },
  };


  const get_color_by_name = (name) => {

    const item = colorManager.find(item => item.container === name);
    return item.value;
  }


  useEffect(() => {
    let rname = localStorage.getItem("rolename");
    setRolename(rname);
    const fetchData = async () => {
        try {
            setIsLoading(true);
                const dataToSend = { begintime: "1",endtime:"2" };
                const data = await requestUrl(dataToSend, "get_lectures_by_userid_and_range", showSnackbar);
                if (data.status === "success") {
                    setEventData(data.data);
                }
            
          } catch (error) {
              console.error("获取数据时出错:", error);
          } finally {
            setIsLoading(false);
          }
    };

    fetchData(); 
  }, []);





  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear().toString().slice(-2); // 获取年份的后两位
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以要+1
    const day = String(date.getDate()).padStart(2, '0');
    const hour = String(date.getHours()).padStart(2, '0');

    return `${year}-${month}-${day}:${hour}`;
  };



  const [currentMonth, setCurrentMonth] = useState(dayjs().startOf("month"));
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedDate,setSelectedDate] = useState('');
    const [addOrEdit,setAddOrEdit] = useState('edit');
  const [showLectureDetail,setShowLectureDetail] = useState(false);
  // 获取当前月份所有日期
  const getDatesInMonth = (month) => {
    const daysInMonth = month.daysInMonth();
    return Array.from({ length: daysInMonth }, (_, i) => month.date(i + 1));
  };







  const [openDialog, setOpenDialog] = useState(false); // 控制对话框的显示
  const [selectedGrade, setSelectedGrade] = useState(null); // 存储选中的班级

  const handleDateClick = (date) => {
    const dateKey = date.format("YYYY-MM-DD");
    const events = eventData[dateKey];
    setSelectedDate(dateKey);
    if (events) {
      if (events.length === 1) {
        // 如果只有一个事件，直接设置
        setShowLectureDetail(true);
        setSelectedEvent(events[0]);
      } else {
        // 如果有多个事件，打开选择对话框
        setOpenDialog(true);
        setSelectedGrade(null); // 清空之前的选择
      }
    }
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleGradeSelect = (event) => {
    const selectedGrade = event.target.value;
    setSelectedGrade(selectedGrade);

    // 根据选择的班级设置对应的事件
    const dateKey = selectedDate;
    const selectedEvent = eventData[dateKey].find((e) => e.grade_name === selectedGrade);
    setSelectedEvent(selectedEvent);
    setShowLectureDetail(true);

    // 关闭对话框
    handleDialogClose();
  };






  // 点击日期，查看详情
  const handleDateClick121212 = (date) => {
    const dateKey = date.format("YYYY-MM-DD");
    if (eventData[dateKey]) {
        setShowLectureDetail(true);
      setSelectedEvent(eventData[dateKey][0]);
      setSelectedDate(dateKey);
    }
  };
  
  const handleCrateLEcture = async () => {
    setAddOrEdit("add");

    setShowLectureDetail(true);
  }


  const handleCloseLecDetail = () => {
    setSelectedEvent(null);
    setShowLectureDetail(false);

  }
  



    return (
       <div style={{ textAlign: "center", padding: "20px", backgroundColor: "#f4f6f9" }}>
      <Typography variant="h4" style={{ marginBottom: "20px", fontWeight: "bold" ,color:"black"}}>
        {currentMonth.format("YYYY 年 MM 月")}
        <Button
          variant="contained"
          onClick={() => setCurrentMonth(currentMonth.subtract(1, "month"))}
          style={{
            marginRight: "30px",
            backgroundColor: "#007bff",
            color: "white",
            borderRadius: "8px",
          }}
        >
          上个月
        </Button>
        <Button
          variant="contained"
          onClick={() => setCurrentMonth(currentMonth.add(1, "month"))}
          style={{
            backgroundColor: "#007bff",
            color: "white",
            borderRadius: "8px",
            marginRight: "30px",
          }}
        >
          下个月
        </Button>
        {rolename === "admin" && (
            <Button
          variant="contained"
          onClick={handleCrateLEcture}
          style={{
            backgroundColor: "#007bff",
            color: "white",
            borderRadius: "8px",
            marginRight: "30px",
          }}
        >
          新建
        </Button>
        )}
      </Typography>
      
 

      {/* 渲染当前月份的所有日期 */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(6, 1fr)", // 每列占 1fr 的空间
          gap: "5px", // 列与列之间的水平间隙为 20px
          justifyItems: "center",
        }}
      >
       



       {getDatesInMonth(currentMonth).map((date) => {
            const dateKey = date.format("YYYY-MM-DD");
            const events = eventData[dateKey];

            // 如果当天有多个事件，获取所有的 grade_name，并用空格拼接
            const gradeNames = events
                ? events.map((event) => event.grade_name).join(" ") // 拼接多个 grade_name
                : "";

  return (
    <Button
      key={dateKey}
      variant="outlined"
      onClick={() => handleDateClick(date)}
      style={{
        width: "220px", // 日期框宽度为 220px
        height: "120px", // 日期框高度为 120px
        fontSize: "16px",
        backgroundColor: events ? "#455a64" : "white", // 背景色
        border: events ? "2px solid #607d8b" : "1px solid #e0e0e0", // 边框颜色
        borderRadius: "15px", // 圆角
        boxShadow: events ? "0 4px 8px rgba(0, 0, 0, 0.2)" : "0 4px 6px rgba(0, 0, 0, 0.1)", // 阴影效果
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px", // 内边距
        transition: "all 0.3s ease", // 平滑过渡效果
        cursor: "pointer", // 鼠标指针样式
        position: "relative",
      }}
    >
      {/* 显示多个班级名称 */}
      {gradeNames && (
        <Typography
          variant="body1"
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            color: events ? "white" : "black",
            position: "absolute",
            top: "5px",
          }}
        >
          {gradeNames}
        </Typography>
      )}

      {/* 显示日期 */}
      <Typography variant="h6" style={{ fontWeight: "bold", color: events ? "white" : "black" }}>
        {date.format("DD")} ({date.locale("zh-cn").format("dddd")})
      </Typography>

      {/* 显示去除 HTML 标签后的内容 */}
      {events && events[0]?.content && (
        <Typography
          variant="body2"
          style={{
            fontSize: "12px",
            color: events ? "white" : "black", // 
            marginTop: "4px",
            textAlign: "center",
            fontWeight: "bold",
          }}
        >
          {events[0].content.replace(/<\/?[^>]+(>|$)/g, "").length > 8
            ? events[0].content.replace(/<\/?[^>]+(>|$)/g, "").substring(0, 20) + "..."
            : events[0].content.replace(/<\/?[^>]+(>|$)/g, "")}
        </Typography>
      )}
    </Button>
  );
})}





      </div>

      {/* 事件详情弹窗 */}
      <Dialog
            open={showLectureDetail}
            onClose={() => {
                setSelectedEvent(null);
                setShowLectureDetail(false);
              }}
            maxWidth={false} // 允许自定义宽高
            PaperProps={{
                style: {
                width: "88vw", // 宽度 85% 视口宽度
                height: "85vh", // 高度 85% 视口高度
                maxWidth: "none", // 取消默认最大宽度限制
                maxHeight: "none", // 取消默认最大高度限制
                },
            }}
            >
  <DialogTitle>{selectedEvent?.grade_name} 日期:{selectedDate} 上课内容如下</DialogTitle>
  <DialogContent style={{ height: "calc(85vh - 64px)" }}>
    <WangEditorLectures data={selectedEvent} selectedDate={selectedDate} addedit={addOrEdit} onClose={handleCloseLecDetail} />
  </DialogContent>
</Dialog>


<Dialog
        open={openDialog}
        onClose={handleDialogClose}
        sx={{
          "& .MuiDialog-paper": {
            width: '400px',  // 设置宽度为400px
            height: '300px', // 设置高度为300px
            margin: 'auto',  // 居中显示
            padding: '20px', // 内边距
          }
        }}
      >
        <DialogTitle>选择班级</DialogTitle>
        <DialogContent>
          <FormControl fullWidth>
            <InputLabel>班级</InputLabel>
            <Select
              value={selectedGrade}
              onChange={handleGradeSelect}
              label="班级"
            >
              {eventData[selectedDate]?.map((event) => (
                <MenuItem key={event.grade_name} value={event.grade_name}>
                  {event.grade_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            取消
          </Button>
        </DialogActions>
      </Dialog>
    </div>
    )
}

export default LecturesContent